import React from 'react'
import { formatValueV2, formatValueNumeral } from '../../helpers/funcs'

const CountryExtraInfo = props => (
    <div className="print-none country-extra-info">
        <ul className="list-inline">
            <li className="list-inline-item"><span>Population</span> {props.contributor.Population > 0 ? formatValueV2(props.contributor.Population, '0,0') : '-'}</li>
            <li className="list-inline-item"><span>GDP</span> {props.contributor.GDP > 0 ? formatValueV2(props.contributor.GDP) : '-'}</li>
            <li className="list-inline-item"><span>Emissions per capita</span> {props.contributor.EmissionsPC > 0 ? formatValueNumeral(props.contributor.EmissionsPC).format('0.00') : '-'}</li>
            <li className="list-inline-item float-sm-right source">Source: World Bank</li>
        </ul>
    </div>
)

export default CountryExtraInfo